/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import PromLogo from './prom-app-icon.svg';
import GooglePlayImg from './download-app-googlePlay.svg';
import AppStoreImg from './download-app-appleStore.svg';
import { isiOS, isIpadOS, isAndroidPhone } from '../utils/string';
import { StyledDownloadApp } from './downloadAppStyles';
export var EmbersDownloadApp = function EmbersDownloadApp(props) {
  var mixpanelProps = props.mixpanelProps;
  var tracker = mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tracker;
  var intl = useIntl();
  var handleDownload = function handleDownload(type) {
    var _tracker$getPromethea;
    tracker === null || tracker === void 0 || (_tracker$getPromethea = tracker.getPrometheanApp) === null || _tracker$getPromethea === void 0 || _tracker$getPromethea.call(tracker, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.pageView, type);
    if (type === 'iOS') {
      window.location.assign('https://apps.apple.com/us/app/mypromethean/id1447288595?ls=1');
    } else if (type === 'Android') {
      window.location.assign('https://play.google.com/store/apps/details?id=com.prometheanworld.mobile.teacher_app');
    }
  };
  return /*#__PURE__*/React.createElement(StyledDownloadApp, {
    className: "EmbersDownloadApp-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersDownloadApp-title"
  }, /*#__PURE__*/React.createElement("img", {
    src: PromLogo,
    alt: "logo"
  }), /*#__PURE__*/React.createElement("span", null, intl.formatMessage({
    id: 'embers.myPrometheanHome.getPrometheanApp.title',
    defaultMessage: 'Get the Promethean app'
  }))), /*#__PURE__*/React.createElement("p", {
    className: "EmbersDownloadApp-content"
  }, intl.formatMessage({
    id: 'embers.myPrometheanHome.getPrometheanApp.content',
    defaultMessage: 'Wirelessly share your screen to ActivPanel, easily manage your account and watch our Learn Promethean videos.'
  })), /*#__PURE__*/React.createElement("div", {
    className: "EmbersDownloadApp-download"
  }, isiOS(navigator.userAgent) || isIpadOS(navigator.userAgent) ? /*#__PURE__*/React.createElement("img", {
    src: AppStoreImg,
    alt: "app-store",
    onClick: function onClick() {
      return handleDownload('iOS');
    }
  }) : isAndroidPhone(navigator.userAgent) ? /*#__PURE__*/React.createElement("img", {
    src: GooglePlayImg,
    alt: "google-play",
    onClick: function onClick() {
      return handleDownload('Android');
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "EmbersDownloadApp-group"
  }, /*#__PURE__*/React.createElement("img", {
    src: AppStoreImg,
    alt: "app-store",
    onClick: function onClick() {
      return handleDownload('iOS');
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: GooglePlayImg,
    alt: "google-play",
    onClick: function onClick() {
      return handleDownload('Android');
    }
  }))));
};